import { transport } from "@/src/config/apiConfig.js";

export default {
  async createAlertAgent(agentData) {
    try {
      const res = await transport.post("/api/alerts/v1/alert-agents", {
        agent_name: agentData.agent_name,
        alert_frequency: agentData.alert_frequency,
        alert_time_unit: agentData.alert_time_unit,
        agent_owner_id: agentData.agent_owner_id,
        alert_agent_info: agentData.alert_agent_info,
        remediation_approach: agentData.remediation_approach,
        object_name: agentData.object_name,
        object_filters: agentData.object_filters,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing createAlertAgent: ",
        error,
      );
      throw error;
    }
  },

  async listAlertAgents(
    page = 1,
    limit = 20,
    ownerId = null,
    searchQuery = null,
  ) {
    try {
      const params = { page, limit };
      if (ownerId) {
        params.owner_id = ownerId;
      }
      if (searchQuery) {
        params.search = searchQuery;
      }
      const res = await transport.get("/api/alerts/v1/alert-agents", {
        params,
      });
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing listAlertAgents: ",
        error,
      );
      throw error;
    }
  },

  async getAlertAgent(agentId) {
    try {
      const res = await transport.get(`/api/alerts/v1/alert-agents/${agentId}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing getAlertAgent: ", error);
      throw error;
    }
  },

  async updateAlertAgent(agentId, agentData) {
    try {
      const res = await transport.put(
        `/api/alerts/v1/alert-agents/${agentId}`,
        {
          agent_name: agentData.agent_name,
          alert_frequency: agentData.alert_frequency,
          alert_time_unit: agentData.alert_time_unit,
          agent_owner_id: agentData.agent_owner_id,
          alert_agent_info: agentData.alert_agent_info,
          remediation_approach: agentData.remediation_approach,
          is_active: agentData.is_active,
          object_name: agentData.object_name,
          object_filters: agentData.object_filters,
        },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing updateAlertAgent: ",
        error,
      );
      throw error;
    }
  },

  async deleteAlertAgent(agentId) {
    try {
      const res = await transport.delete(
        `/api/alerts/v1/alert-agents/${agentId}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing deleteAlertAgent: ",
        error,
      );
      throw error;
    }
  },

  async toggleAlertAgent(agentId, isActive) {
    try {
      const res = await transport.patch(
        `/api/v1/alert-agents/${agentId}/toggle`,
        { is_active: isActive },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing toggleAlertAgent: ",
        error,
      );
      throw error;
    }
  },

  async listAlerts(
    page = 1,
    limit = 20,
    priority = null,
    searchQuery = null,
    ownerId = null,
    alertAgentId = null,
    status = null,
  ) {
    try {
      const params = { page, limit };
      if (priority) {
        params.priority = priority;
      }
      if (searchQuery) {
        params.search = searchQuery;
      }
      if (ownerId) {
        params.owner_id = ownerId;
      }
      if (alertAgentId) {
        params.alert_agent_id = alertAgentId;
      }
      if (status) {
        params.status = status;
      }
      const res = await transport.get("/api/alerts/v1/alerts", { params });
      return res.data;
    } catch (error) {
      console.error("An error occurred while executing listAlerts: ", error);
      throw error;
    }
  },

  async updateAlertStatus(alertId, status) {
    try {
      const res = await transport.put(
        `/api/alerts/v1/alerts/${alertId}/status`,
        { status },
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while executing updateAlertStatus: ",
        error,
      );
      throw error;
    }
  },
};
